import { Container } from "react-grid-system"
import styled from "styled-components"
import media from "styleguide/styles/media-queries"

const ContainerWrapper = styled(Container)`
  ${media.phone`
    padding-left: 32px !important;
    padding-right: 32px !important;
  `}
`

export default ContainerWrapper
